<button class="ui-button d-flex align-items-center" [ngClass]="classList()" [disabled]="disabled()" [type]="type()">
  <div class="label">{{ label() }}</div>
</button>
